























































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeMapaCirurgicoGradeStore from '@/components/Backoffice/Store/BackofficeMapaCirurgicoGradeStore'
import BackofficeDataAgendamentoStore from '@/components/Backoffice/Store/BackofficeDataAgendamentoStore'
import { permissionService } from '@/services/permission.service'
import ChatStore from '@/components/Chat/Store/ChatStore'
import moment from 'moment'
import { tz } from 'moment-timezone'
import { convertH2M } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import timeGrid from '@fullcalendar/timegrid'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import { TipoReservaSalaEnum, MotivoTransferenciaReserva, SendReservaSala } from '@/types/_'

@Component({ components: { FullCalendar } })
export default class ComponentFinxCalendar extends Vue {
  @Prop({ default: {}, required: true }) extraOptions: object

  $refs!: {
    calendarComponent: any
    formMotivosTransferenciaReserva: any
  }

  get getBackofficeMapaCirurgicoGradeStore() {
    return getModule(BackofficeMapaCirurgicoGradeStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeDataAgendamentoStore() {
    return getModule(BackofficeDataAgendamentoStore, this.$store)
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get hospital() { return this.getBackofficeMapaCirurgicoGradeStore.hospital }

  solicitacaoOptions: boolean = false
  selectedEvent: any = {}
  eventDropDialog: boolean = false
  eventDropRevert: any = { current: () => false }

  /** MOTIVO DE TRANSFERÊNCIA */
  formMotivosTransferenciaReservaRules: any = {
    valid: true,
    motivoTransferenciaReserva: [(v: MotivoTransferenciaReserva) => this.validateMotivo(v)],
  }

  validateMotivo(value: MotivoTransferenciaReserva) {
    return !value || ['', null, undefined].includes(value.id) ? 'Campo obrigatório.' : false
  }

  loadJustificar: boolean = false
  get loadingJustificar() { return this.loadJustificar }
  set loadingJustificar(value: boolean) { this.loadJustificar = value }

  get motivosTransferenciaReserva() { return this.getBackofficeMapaCirurgicoGradeStore.motivosTransferenciaReserva }
  get motivoTransferenciaReserva() { return this.getBackofficeMapaCirurgicoGradeStore.motivoTransferenciaReserva }
  set motivoTransferenciaReserva(value: MotivoTransferenciaReserva) { this.getBackofficeMapaCirurgicoGradeStore.setMotivoTransferenciaReserva(value) }


  async justificar() {
    if (this.hospital.hospitalInformaMotivoDeTransferenciaReserva && !this.$refs.formMotivosTransferenciaReserva.validate()) return
    this.loadingJustificar = true
    const { event, newResource } = this.selectedEvent
    const request = await this.getBackofficeMapaCirurgicoGradeStore.backofficeAgendamentoAlteraReserva(this.formatReservaSalaRequest(event, newResource))

    if (!request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828', timeout: 7500 })
      this.loadingJustificar = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Reagendamento realizado com sucesso!', icon: 'done', color: '#2E7D32' })

    // Atualiza os eventos
    const { calendarComponent } = this.$refs
    this.getBackofficeMapaCirurgicoGradeStore.updateEvent(this.selectedEvent)
    await calendarComponent.getApi().render()

    this.loadingJustificar = false
    this.eventDropDialog = false
  }

  @Watch('eventDropDialog')
  onChangeEventDropDialog(value: boolean) {
    if (!value) {
      this.getBackofficeMapaCirurgicoGradeStore.clearMotivoTransferenciaReserva()
      if (this.hospital.hospitalInformaMotivoDeTransferenciaReserva) {
        this.$refs.formMotivosTransferenciaReserva.reset()
        this.$refs.formMotivosTransferenciaReserva.resetValidation()
      }
      this.selectedEvent = {}
    }
  }

  formatReservaSalaRequest(event: any, newResource: any) {
    const params: SendReservaSala = {
      solicitacaoId: event.extendedProps.solicitacaoId,
      salaId: newResource && newResource.extendedProps ? newResource.extendedProps.salaCirurgicaId : event.extendedProps.salaCirurgicaId,
      // eslint-disable-next-line no-nested-ternary
      centroCirurgicoId: this.getBackofficeMapaCirurgicoGradeStore.shouldGroupFields
        ? (newResource && newResource.extendedProps) ? newResource.extendedProps.centroCirurgicoId : event.extendedProps.centroCirurgicoId
        : undefined,
      numeroAgendamento: event.extendedProps.numeroAgendamento || '',
      dataAgendamentoVirtual: event.extendedProps.dataAgendamentoVirtual || false,
      motivoTransferenciaReservaId: this.hospital.hospitalInformaMotivoDeTransferenciaReserva
        ? String(this.motivoTransferenciaReserva.id)
        : undefined,
      tempoCirurgia: event.extendedProps.tempoCirurgia || convertH2M(event.endStr) - convertH2M(event.startStr) - event.extendedProps.tempoPreparacaoSalaCirurgica,
      data: event.startStr.split('T')[0],
      hora: event.startStr.split('T')[1],
      inicio: event.startStr,
      fim: moment(event.endStr).subtract(event.extendedProps.tempoPreparacaoSalaCirurgica, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
    }

    Object.entries(params).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) {
        delete params[key]
      }
    })

    return {
      solicitacaoId: params.solicitacaoId,
      payload: params.dataAgendamentoVirtual && !this.hospital.hospitalDataVirtualFazReservaDeSala
        ? { reservaVirtual: params }
        : { reservaSala: params },
    }
  }

  loadCalendar: boolean = false
  get loadingCalendar() { return this.loadCalendar }
  set loadingCalendar(value: boolean) { this.loadCalendar = value }

  loadVisualizar: boolean = false
  get loadingVisualizar() { return this.loadVisualizar }
  set loadingVisualizar(value: boolean) { this.loadVisualizar = value }

  loadAlterarReserva: boolean = false
  get loadingAlterarReserva() { return this.loadAlterarReserva }
  set loadingAlterarReserva(value: boolean) { this.loadAlterarReserva = value }

  get eventByLabelType() {
    return this.getBackofficeMapaCirurgicoGradeStore.eventByLabelType
  }

  formatAgendamento(event: any) {
    return `${moment(tz(event.start, 'Europe/Reykjavik')).format('DD/MM/YYYY')} de ${moment(tz(event.start, 'Europe/Reykjavik')).format('HH:mm')} até ${moment(tz(event.end, 'Europe/Reykjavik')).format('HH:mm')}`
  }

  formatCentroCirurgicoSala(arg: any) {
    if (arg.newResource) {
      if (arg.newResource.extendedProps.centroCirurgicoNome) return `${arg.newResource.extendedProps.centroCirurgicoNome} / ${arg.newResource.extendedProps.salaCirurgicaNome}`
      return arg.newResource.extendedProps.salaCirurgicaNome
    }

    if (arg.event.extendedProps.centroCirurgicoNome) return `${arg.event.extendedProps.centroCirurgicoNome} / ${arg.event.extendedProps.salaCirurgicaNome}`
    return arg.event.extendedProps.salaCirurgicaNome
  }

  handleEventDropCancel() {
    if (this.eventDropRevert.current) this.eventDropRevert.current()
    this.eventDropDialog = false
    this.eventDropRevert.current = () => false
  }

  handleEventDrop(eventoInfo: any) {
    if (permissionService.hasPermission('agendamento.backoffice.mapacirurgico.bloqueioAcoes')) {
      eventoInfo.revert()
    } else {
      this.eventDropRevert.current = eventoInfo.revert
      this.selectedEvent = { ...eventoInfo }
      this.eventDropDialog = true
    }
  }

  handleEventActions(actionInfo: any) {
    if (!permissionService.hasPermission('agendamento.backoffice.mapacirurgico.bloqueioAcoes')) {
      if (!['AgendamentoApenasNoHis', 'PreAgendamento'].includes(actionInfo.event.extendedProps.tipoReservaSala)) {
        this.selectedEvent = { ...actionInfo }
        this.solicitacaoOptions = true
      }
    }
  }

  handleDatesSet(dateInfo: any) {
    EventBus.$emit('calendarUpdateDatesSet', dateInfo)
  }

  async showAlterarReserva(item: any) {
    this.loadingAlterarReserva = true
    const { solicitacaoId } = item.event.extendedProps

    await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)

    if (this.getBackofficeGlobalStore.componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
      const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(solicitacaoId)
      if (response.success) {
        await this.getChatStore.getDataAgendamento(solicitacaoId)
        await this.getBackofficeGlobalStore.getHospitalTemplate(solicitacaoId)
        this.getBackofficeGlobalStore.setmapaCirurgicoGradeAlterarReserva(true)
        this.getBackofficeGlobalStore.setModal({ name: 'reservaDeSala', value: true })
      }
    } else {
      const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
        const itemReserva = this.getBackofficeGlobalStore.solicitacao
        this.getBackofficeGlobalStore.setmapaCirurgicoGradeAlterarReserva(true)
        await this.getChatStore.getDataAgendamento(solicitacaoId)
        // @ts-ignore
        this.getBackofficeDataAgendamentoStore.setAgendamentoItem({ ...itemReserva })
        this.getBackofficeDataAgendamentoStore.setModal({ name: 'confirmarDataAgendamento', value: true })
      }
    }

    this.loadingAlterarReserva = false
  }

  async showSolicitacao(item: any) {
    const { hospitalId, solicitacaoId, tipoReservaSala } = item.event.extendedProps
    if ([TipoReservaSalaEnum.AgendamentoApenasNoHis].includes(tipoReservaSala)) return
    this.loadingVisualizar = true

    this.getBackofficeGlobalStore.setBackofficeArea('agendamento')
    this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.loadingVisualizar = false
  }

  get calendarOptions() {
    return {
      locale: ptBrLocale,
      plugins: [
        resourceTimelinePlugin,
        interactionPlugin,
        dayGridPlugin,
        timeGrid,
      ],
      headerToolbar: {
        left: 'today,prev,next',
        center: 'title',
        right: '',
      },
      views: {
        resourceTimelineDay: {
          slotLabelFormat: [
            { hour12: false, hour: '2-digit', minute: '2-digit' },
          ],
        },
      },
      slotDuration: '00:30:00',
      eventDrop: this.handleEventDrop,
      eventClick: this.handleEventActions,
      datesSet: this.handleDatesSet,
      ...this.extraOptions,
    }
  }

  @Watch('solicitacaoOptions')
  onChangeSolicitacaoOptions(value: boolean) {
    if (!value) {
      this.selectedEvent = {}
    }
  }

  @Watch('computedEvents')
  async onChangeEvents(value: any[]) {
    const { calendarComponent } = this.$refs
    await calendarComponent.getApi().removeAllEvents()
    await calendarComponent.getApi().setOption('events', value)
    await calendarComponent.getApi().render()
  }
}
